<ion-item class="default-input">
  <ion-input
    [type]="type"
    labelPlacement="stacked"
    [clearInput]="true"
    [placeholder]="placeholder"
    [label]="label"
    [formControl]="control"
  ></ion-input>

  @if (control.errors && showError) {
    <span class="error">{{ errorMessage }}</span>
  }
</ion-item>
